import { ComplexMetadata, flattenComplexObject } from 'utils/format/object'
import { EventSenderPlugin } from '.'
import { Metadata, SendEventData } from '../types'

export class GoogleAnalyticsPlugin extends EventSenderPlugin {
  constructor() {
    super('GoogleAnalytics')
  }

  sendEvent(event: SendEventData) {
    if (!window.gtag) return

    window.gtag(
      'event',
      event.label,
      event.metadata
        ? flattenComplexObject(event.metadata as ComplexMetadata)
        : {}
    )
  }

  updateUserMetadata(metadata: Metadata) {
    if (!window.dataLayer) return

    if (metadata.user_id) {
      window.dataLayer.push({
        user_id: metadata.user_id
      })
    }
  }
}
